import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=06cc7e34&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"
import style0 from "./Slider.vue?vue&type=style&index=0&id=06cc7e34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc7e34",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PropertyCard: require('/app/components/property/Card.vue').default})
